<mat-form-field
  class="dropdown dropdown--filter dropdown-input dropdown-left-0"
  [class.dropdown--simple]="!multiple"
  [class.dropdown--multiple]="multiple"
  floatLabel="never"
  [attr.dropdownOpen]="select.panelOpen"
  [attr.dropdownSelected]="!!select?.value"
  appearance="legacy"
>
  <mat-label class="dropdown-input__label" [class.dropdown-input__label--advanced]="advancedFilterSearchEngine">{{
    label
  }}</mat-label>
  <mat-select
    [formControl]="_control"
    [panelClass]="typePanelClass$ | async"
    #select
    [aria-label]="ariaLabel"
    name="dropdown"
    ngDefaultControl
    (selectionChange)="selectionChanged()"
    (openedChange)="panelTriggered.emit($event)"
    [disableOptionCentering]="true"
    [multiple]="multiple"
  >
    <mat-select-trigger>
      <ng-container *ngIf="!multiple">{{ options[_control.value] }}</ng-container>
      <ng-container *ngIf="multiple">
        <div #inputField class="input-field">
          <div
            class="show-multiple"
            #inputValues
            *ngFor="let value of _control.value; trackBy: trackByIndex"
            [style.min-width]="
              options[value] === (elementNameToReduce$ | async)
                ? (elementToReduceMaxWidth$ | async) + 'px'
                : 'fit-content'
            "
            [style.max-width]="
              options[value] === (elementNameToReduce$ | async) ? (elementToReduceMaxWidth$ | async) + 'px' : 'auto'
            "
          >
            {{ options[value] }}
          </div>
        </div>
        <div *ngIf="(elementHidden$ | async) !== undefined" class="more-box">{{ elementHidden$ | async }}</div>
      </ng-container>
    </mat-select-trigger>
    <mat-option
      *ngFor="let option of options | keyvalue: ascendantOrder; trackBy: trackByOption"
      class="checkbox-option"
      [value]="option.key"
      [disabled]="_maxSelectedReached && !(_control.value | includes: option.key)"
      [style.-ms-grid-column]="ieColumn"
      [style.-ms-grid-row]="ieRow"
      >{{ option.value }}
    </mat-option>
  </mat-select>
  <mat-icon *ngIf="!select?.value" matSuffix svgIcon="arrow_next" role="presentation"></mat-icon>
  <button
    type="button"
    *ngIf="!!select?.value"
    [attr.aria-label]="'Suppression du filtre ' + label | lowercase | upperfirst"
    matSuffix
    class="delete-btn btn-clean"
    (click)="clearValue($event)"
  >
    <mat-icon svgIcon="cross" role="presentation"></mat-icon>
  </button>

  <mat-error *ngIf="(parentFormSubmitted$ | async) && _control?.errors?.required">
    <ng-container *ngIf="!multiple; else multipleRequiredError">Veuillez sélectionner une option</ng-container>
    <ng-template #multipleRequiredError>
      <ng-container>Veuillez sélectionner au moins une option</ng-container>
    </ng-template>
  </mat-error>
</mat-form-field>
